// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fB","advertDetailContacts__header":"c-n_fC"};